import React from 'react';
import { flagUrl } from '../constants/countries';

/** Petit drapeau image (flagcdn), rendu constant cross-OS. */
export function Flag({ iso, size = 18, className = '' }) {
  if (!iso) {
    return (
      <span
        aria-hidden="true"
        className={`inline-block rounded-sm bg-[#E8E6E1] ${className}`}
        style={{ width: size + 4, height: size - 4 }}
      />
    );
  }
  return (
    <img
      src={flagUrl(iso)}
      srcSet={`${flagUrl(iso, 40)} 1x, ${flagUrl(iso, 80)} 2x`}
      alt=""
      aria-hidden="true"
      loading="lazy"
      className={`inline-block rounded-sm object-cover ${className}`}
      style={{ width: size + 4, height: size - 4 }}
    />
  );
}

export default Flag;
